import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CategoryView } from 'ish-core/models/category-view/category-view.model';

@Component({
  selector: 'custom-dot-cms-category-card',
  templateUrl: './dot-cms-category-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DotCmsCategoryCardComponent {
  @Input() stylesCSS: string;
  @Input() category: CategoryView;
  @Input() layout: string;

  categoryImageUrl = '/assets/img/not-available.svg';

  ngOnChanges() {
    this.setCategoryImageUrl();
  }

  /**
   * Set the category image URL from the (non-)empty property effectiveUrl.
   * The URL to a non-empty effectiveUrl has a prefix URL of property icmBaseURL.
   */
  setCategoryImageUrl() {
    if (this.category.images?.[0]?.effectiveUrl?.length > 0) {
      this.categoryImageUrl = `${this.category.images[0].effectiveUrl}`;
    }
  }
}
